import { Reducer, Action } from "redux";
import { ISelectedSocialMediaState, ISelectedSocialMedia, KnownAction, REPIQ_SELECTED_SOCIAL_MEDIA, SHOW_LOADER } from "./types";

export const reducer: Reducer<ISelectedSocialMediaState> = (state: ISelectedSocialMediaState | undefined, incomingAction: Action): ISelectedSocialMediaState => {
    if (state === undefined) {
        return {
            selectedSocialMedia: {} as ISelectedSocialMedia,
            isLoading: false,
        };
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case REPIQ_SELECTED_SOCIAL_MEDIA:
            return {
                ...state,
                selectedSocialMedia: action.selectedSocialMedia,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
